import * as moment from 'moment';
export class TeacherModel {
  id: any;
  umlId: any = null;
  name: string = '';
  description: string = '';
  profileImage: string = '';
  subjects: any = []
  createdAt: any;
  updatedAt: any;



   constructor(public obj: any){
    let serverTime = localStorage.getItem('serverTime');
    let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");

    this.id = obj?.id || '',
    this.umlId = obj?.uml_id ? parseInt(obj.uml_id) : null,
    this.name = obj?.firstName + " " + obj?.lastName || '';
    this.description = obj?.description || '';
    this.profileImage = obj?.photo || 'assets/img/emptyProfile.png';
    this.subjects = this.getSubject(obj?.subjects);
    this.createdAt = obj?.createdAt || new Date(current_time);
    this.updatedAt = obj?.updatedAt || new Date(current_time);
  }

  getSubject(sub: any){
    let subject = []
    if(sub != undefined && sub.length > 0)
      subject =  sub.sort().map((v:any) => v == 'MATH'? 'Maths' : v == 'CHEM'? 'Chemistry' : ['BIOL', 'BIO'].includes(v)? 'Biology' : v == 'PHYS' || v == 'PHY'? 'Physics' : v== 'ZOOL'? 'Zoology' : '');
    return subject;
  }
}
